import { render } from "./limit-currency-configuration.vue?vue&type=template&id=253c8f9c&ts=true"
import script from "./limit-currency-configuration.ts?vue&type=script&lang=ts"
export * from "./limit-currency-configuration.ts?vue&type=script&lang=ts"

import "./limit-currency-configuration.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__